"use client";

import {
  useOnboardingStepModalsFromProps,
  type OnboardingStepModalHostProps,
} from "@/src/hooks/onboarding/useOnboardingStepModalsFromProps";

/** Renders nothing; opens step modals from parent {@link activeStep}. */
export const OnboardingStepModalHost = (
  props: OnboardingStepModalHostProps,
) => {
  useOnboardingStepModalsFromProps(props);
  return null;
};
